<script setup lang="ts">
import AppShell from "@/components/layout/AppShell.vue";
import AuthGate from "@/components/auth/AuthGate.vue";
</script>

<template>
  <AuthGate><AppShell /></AuthGate>
</template>
